<div class="tw-flex tw-flex-col tw-gap-6 tw-w-full">
  <div class="tw-grid tw-grid-cols-2 tw-gap-6 tw-w-full sm:tw-grid-cols-1">
    @for (type of ACCOUNT_TYPES; track type) {
      @if (type.key === "bank") {
        <app-signal-glow-wrapper
          adjustmentClasses="tw-rounded-xl"
          [isSignal]="signalGlowService.isSignal()"
        >
          <ng-container
            *ngTemplateOutlet="accountTile; context: { type: type, click: tileButtonClicked }"
          ></ng-container>
        </app-signal-glow-wrapper>
      } @else {
        <ng-container
          *ngTemplateOutlet="accountTile; context: { type: type, click: tileButtonClicked }"
        ></ng-container>
      }
    }
  </div>
  <div class="tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-3">
    <div
      class="tw-flex tw-w-full tw-border tw-border-dt-surface-elevated tw-shadow-border-bottom"
    ></div>
    <span
      class="tw-text-[14px] tw-font-medium tw-leading-none tw-tracking-normal tw-text-dt-text-tertiary tw-whitespace-nowrap"
      >{{ "selectYourAccountType" | i18n }}</span
    >
    <div
      class="tw-flex tw-w-full tw-border tw-border-dt-surface-elevated tw-shadow-border-bottom"
    ></div>
  </div>
</div>

<ng-template #accountTile let-type="type">
  <tile-button
    class="tw-w-full"
    [title]="type.title | i18n"
    [description]="type.description | i18n"
    (click)="tileButtonClicked(type.key)"
    [testId]="getAccountTypeTestId(type.key)"
  >
    <div
      class="tw-rounded-2xl tw-shadow-dropdown tw-w-[48px] tw-h-[48px] tw-flex tw-items-center tw-justify-center"
      [ngClass]="{
        'tw-bg-dt-indigo-9/10': type.key === 'bank',
        'tw-bg-account-credit/10': type.key === 'credit',
        'tw-bg-account-stock/10': type.key === 'stock',
        'tw-bg-account-other/10': type.key === 'other',
      }"
    >
      <icon [name]="type.key + '-account'" [sizeArbitrary]="'24px'"></icon>
    </div>
  </tile-button>
</ng-template>
